import brand from '@helpers/brand';
import { fonts } from '@helpers/fonts';
import styled, { css } from 'styled-components';
import { LoginSignupStyles } from '../LoginSignup.styles';
const Container = styled.div `
  width: 100%;
  height: 100%;
  overflow-y: scroll;

  ${LoginSignupStyles.FormContainer} {
    height: fit-content;

    ${LoginSignupStyles.FormWrapper} {
      background-color: ${brand.white};
      border-top: 5px solid ${brand.primary.alt};
      max-width: 750px;
      padding: 40px 20px 60px;

      ${LoginSignupStyles.FormContent} {
        max-width: 70%;
      }

      ${LoginSignupStyles.FormTitle} {
        text-align: center;
      }
    }
  }
`;
const PasswordInfo = styled.span `
  ${fonts.DaxPro.Medium};
  font-size: 14px;
  width: 100%;

  ${({ green }) => green &&
    css `
      color: ${brand.primary.dark};
    `};
`;
const Link = styled.span `
  text-decoration: underline;
  color: ${brand.primary.light};
  cursor: pointer;

  &:hover {
    color: ${brand.primary.base};
  }
`;
export const SignupFormStyles = {
    Container,
    PasswordInfo,
    Link,
};
